__turbopack_context__.v({
  "buttonContainer": "giving-back-module__lIvP8G__buttonContainer",
  "expanded": "giving-back-module__lIvP8G__expanded",
  "globeOverlayContainer": "giving-back-module__lIvP8G__globeOverlayContainer",
  "heroBadge": "giving-back-module__lIvP8G__heroBadge",
  "heroContainer": "giving-back-module__lIvP8G__heroContainer",
  "heroVideo": "giving-back-module__lIvP8G__heroVideo",
  "ourCertificatesChevron": "giving-back-module__lIvP8G__ourCertificatesChevron",
  "ourCertificatesHeading": "giving-back-module__lIvP8G__ourCertificatesHeading",
  "ourCertificatesHr": "giving-back-module__lIvP8G__ourCertificatesHr",
  "ourCertificatesIcon": "giving-back-module__lIvP8G__ourCertificatesIcon",
  "ourCertificatesImages": "giving-back-module__lIvP8G__ourCertificatesImages",
  "reasonButton": "giving-back-module__lIvP8G__reasonButton",
  "reasonButtonSelected": "giving-back-module__lIvP8G__reasonButtonSelected",
  "reasonContainer": "giving-back-module__lIvP8G__reasonContainer",
  "reasonImage": "giving-back-module__lIvP8G__reasonImage",
  "reasonText": "giving-back-module__lIvP8G__reasonText",
  "resultsItem": "giving-back-module__lIvP8G__resultsItem",
  "resultsList": "giving-back-module__lIvP8G__resultsList",
  "sideBySideImages": "giving-back-module__lIvP8G__sideBySideImages",
  "sideBySideImagesWithRoundedCorners": "giving-back-module__lIvP8G__sideBySideImagesWithRoundedCorners",
  "tabBar": "giving-back-module__lIvP8G__tabBar",
  "treesSubtext": "giving-back-module__lIvP8G__treesSubtext",
  "verifiableTreesHeader": "giving-back-module__lIvP8G__verifiableTreesHeader",
});
